<template>
    <div style="padding:8px 8px;border-bottom:1px solid #ddd;">
        <div class="row no-gutters" v-if="title || note">
            <div v-if="title" class="col settings-title"><span class="icon" v-html="iconHtml" v-if="icon"></span> {{title}}</div>
            <div v-if="note" class="col settings-note text-right">{{note}}</div>
        </div>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'SettingsPart',
    components: {},
    props: ['title', 'icon', 'note'],
    data() {
        return {

        }
    },
    created() {
    },
    computed: {
        iconHtml: function() {
            if(this.icon) {
                if(this.icon == 'pro') {
                    return "<span style='border: medium; border-radius: 3px; font-size: 14px; color: rgb(255, 255, 255); padding: 1px 3px; margin-top: 2px; margin-left: 2px; margin-right: 3px; background-color: rgb(132, 186, 69);'>Pro</span>"
                } else {
                    return "<i class='bi bi-"+this.icon+"'></i>";
                }
            }
            return "<i class='bi bi-sliders'></i>";
        }   
    },
    mounted() {

    },
    methods: {
    }
}
</script>

<style scoped>
    div.settings-title {
        color:#666;
        font-weight:600;
    }
    div.settings-note {
        color:#888;
        font-weight:400;
    }
</style>